import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { ConstantsModule } from './../constants/constants.module';
import { DialogPage } from './../root_classes/dialog-page';

@Component({
  selector: 'app-company-edit',
  templateUrl: './company-edit.component.html',
  styleUrls: ['./company-edit.component.scss']
})
export class CompanyEditComponent extends DialogPage {

	// Form data.
	companyEditForm = new FormGroup({
		nameControl: new FormControl('', [Validators.required]),
	});

	// Extra data.
	public companyId: string = "";
	public companyName: string = "";
	public buttonText: string = "Modifier";
	public enableAction: boolean = true;

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal, modalInstance: NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);
	}

	public setModalOptions(data: any): void {
		this.companyId = data["id"];
		this.companyName = data["name"];
		this.companyEditForm.controls["nameControl"].setValue(data["name"]);
	}

	public save(): void {
		// Disabling button.
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
			"name": this.companyEditForm.controls["nameControl"].value.toUpperCase(),
			"id": this.companyId
		};
		this.put("/api/company-rename", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					this.modalInstance.dismiss(newData);
				}
			},
			(err:any) => {
				this.modalInstance.close(err);
			}
		);
	}
}
